import React, { useState } from 'react';
import { emiAPI } from '../../services/api';
import { formatCurrency } from '../../utils/format';

export default function CollectEmiModal({ emi, onClose, onSuccess }) {
  const [amount, setAmount] = useState(emi.nextAmount != null ? String(emi.nextAmount) : '');
  const [note, setNote] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [err, setErr] = useState('');

  const handleCollect = async () => {
    const amt = Number(amount);
    if (!amt || amt <= 0) { setErr('Enter a valid amount.'); return; }
    setSubmitting(true); setErr('');
    try {
      const res = await emiAPI.collect(emi._id, { amount: amt, paymentMode: 'Cash', note });
      let msg = res.data?.whatsappQueued
        ? 'Payment saved. WhatsApp receipt sent.'
        : 'Payment saved.';
      if (res.data?.bonusCommission?.created) {
        msg += ` EMI bonus commission ₹${res.data.bonusCommission.amount} added to My Commission.`;
      }
      if (res.data?.emi?.status === 'completed' && !res.data?.bonusCommission?.created) {
        msg += ' EMI closed — bonus will appear in commission when collection threshold is met.';
      }
      onSuccess(msg);
    } catch (e) {
      setErr(e.response?.data?.message || 'Collection failed. Please retry.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="collect-modal" onClick={(e) => e.stopPropagation()}>
        <div className="collect-modal-header">
          <div>
            <div className="fw-700" style={{ fontSize: 16 }}>Collect Installment</div>
            <div className="text-muted" style={{ fontSize: 13 }}>{emi.customerName} · {emi.productName}</div>
          </div>
          <button className="btn-close-modal" onClick={onClose}>×</button>
        </div>
        <div className="collect-modal-body">
          <div className="collect-snapshot">
            <div className="collect-snap-row"><span className="text-muted">Customer</span><strong>{emi.customerName}</strong></div>
            <div className="collect-snap-row"><span className="text-muted">Phone</span><span>{emi.customerPhone || '—'}</span></div>
            <div className="collect-snap-row"><span className="text-muted">Progress</span><span>{emi.paidMonths || 0}/{emi.totalMonths} paid</span></div>
            <div className="collect-snap-row">
              <span className="text-muted">KYC / Witness</span>
              <span>
                {emi.kycComplete ? <span className="chip badge-kyc-complete ms-0 me-1">KYC ✓</span> : <span className="chip badge-kyc-pending ms-0 me-1">KYC ✗</span>}
                {emi.witnessOnFile ? <span className="chip badge-witness ms-0">Witness ✓</span> : <span className="chip badge-kyc-pending ms-0">No Witness</span>}
              </span>
            </div>
          </div>

          <div className="mt-3">
            <label className="form-label">Collection amount <span className="text-muted ms-2" style={{ fontWeight: 400 }}>Suggested: {formatCurrency(emi.nextAmount)}</span></label>
            <input type="number" className="form-control" value={amount} onChange={(e) => setAmount(e.target.value)} min={1} autoFocus />
          </div>
          <div className="mt-2">
            <label className="form-label">Note (optional)</label>
            <input type="text" className="form-control" value={note} onChange={(e) => setNote(e.target.value)} />
          </div>
          {err && <div className="alert-soft danger mt-2">{err}</div>}
        </div>
        <div className="collect-modal-footer">
          <button className="btn btn-outline-secondary" onClick={onClose} disabled={submitting}>Cancel</button>
          <button className="btn btn-success" onClick={handleCollect} disabled={submitting}>{submitting ? 'Saving…' : `Collect ${formatCurrency(amount || 0)}`}</button>
        </div>
      </div>
    </div>
  );
}
